import { createAction, props } from '@ngrx/store';
import { Entity, FormatGroup } from '../../entity/models/entity';
import { LoadListItemsPayload } from '../../list/models/list';
import { ListPagination, ListSortByString } from '../../list/models/list.dto';
import { LibraryList, LibraryListTypes } from '../reducers/library-list.reducer';

export interface LibraryListItemsPayload extends Omit<LoadListItemsPayload, 'sort'> {
  sort: ListSortByString;
  libraryListType?: LibraryListTypes
}

export const loadLibraryList = createAction(
  '[LibraryList] Load library list by Id',
  props<{ id: string, libraryListType: LibraryListTypes }>(),
);

export const loadLibraryListSuccess = createAction(
  '[LibraryList] Load library list success',
  props<{ libraryList: LibraryList }>(),
);

export const loadLibraryListFailure = createAction(
  '[LibraryList] Load library list failure',
  props<{ errorCode: number }>(),
);

export const loadLibraryListItems = createAction(
  '[LibraryList] Load library list items',
  props<LibraryListItemsPayload>(),
);

export const loadLibraryListItemsSuccess = createAction(
  '[LibraryList] Load library list items success',
  props<{ pagination: ListPagination }>(),
);

export const loadLibraryListItemsFailure = createAction(
  '[LibraryList] Load library list items failure',
  props<{ errorCode: number }>(),
);

export const addLoadedLibraryListItems = createAction(
  '[LibraryList] Add loaded library list items',
  props<{ entities: (Entity | FormatGroup)[] }>(),
);

export const loadMoreLibraryListItems = createAction(
  '[LibraryList] Load more library list items',
);

export const clearLibraryListItems = createAction(
  '[LibraryList] Clear library list items',
);
